import { useSelector } from 'react-redux';
import {
  getCapabilityPermission,
  hasLoadedCapabilities,
  isCapabilityAccessible,
  isCapabilityVisible,
} from '../utils/capabilityUtils';

export const useCapability = (capabilityKey) => {
  const capabilities = useSelector((state) => state.orgSettings.capabilities);
  const loaded = hasLoadedCapabilities(capabilities);
  const visible = loaded ? isCapabilityVisible(capabilities, capabilityKey) : false;
  const accessible = loaded ? isCapabilityAccessible(capabilities, capabilityKey) : false;

  return {
    capabilities,
    loaded,
    visible,
    accessible,
    isRestricted: visible && !accessible,
    permission: getCapabilityPermission(capabilities, capabilityKey),
  };
};
